//
//
//
//
//
//
//
//
//

/**
 * Компонент для объеденения радио-кнопок в группу
 * ```vue live
 * <HseRadioGroup>
 *   <HseRadio value="1" checked>Вариант №1</HseRadio>
 *   <HseRadio value="2" inactive>Вариант №2</HseRadio>
 * </HseRadioGroup>
 * ```
 */
var script = {
  name: 'HseRadioGroup',

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    modelValue: {
      type: [String, Number],
      default: undefined
    },
    name: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      value: undefined
    }
  },

  watch: {
    modelValue () {
      this.value = this.modelValue;
    },
    value () {
      this.$emit('change', this.value);
    }
  },

  created () {
    this.value = this.modelValue;
  }
};

export default script;
